import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import objectSupport from 'dayjs/plugin/objectSupport'
import weekday from 'dayjs/plugin/weekday'
import 'dayjs/locale/zh-tw'
import 'dayjs/locale/zh-cn'

dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(objectSupport)
dayjs.extend(weekday)

export default dayjs
